import React, { useEffect, useState } from "react";
import BBCode from "@bbob/react";
import presetReact from "@bbob/preset-react";
import SteamNewsImage from "../resources/images/steam_news.png";

function steamToBBCode(content: string) {
    return content
        // fix lists
        .replace(/\[list\]/gi, '[ul]')
        .replace(/\[\/list\]/gi, '[/ul]')
        .replace(/\[\*\]/g, '[li]')
        .replace(/\[\/\*\]/g, '[/li]')
}

const STEAM_API_URL = '/ISteamNews/GetNewsForApp/v2/?appid=3774800&count=100';

const SteamNews = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(process.env.NODE_ENV === "production" ? "/api/steam" + STEAM_API_URL : STEAM_API_URL);
                const data = await response.json();
                setNews(data.appnews.newsitems);
            } catch (error) {
                console.error("Error fetching Steam news:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    if (loading) return <p>Loading news...</p>;

    return (
        <div className="each-element mt90 clearfix">
            <div className="container">
                <div className="row g-5">
                    {news.slice(0, 6).map((item: any) => (
                        <div key={item.gid} className="item col-xxl-4 col-xl-12">
                            <div className="news--image" style={{padding: 90}}>
                                <img src={SteamNewsImage} alt="" style={{height: "inherit", maxHeight: 140}} />
                            </div>
                            <div className="item-info equal-height news-body" style={{maxHeight: 554, overflow: "hidden"}}>
                                <div className="item-header table fsize-14 fweight-700 uppercase">
                                    <div className="table-cell color-2 text-right">{new Date(item.date * 1000).toLocaleDateString()}</div>
                                </div>
                                <div className="item-title mt20"><a href={item.url} target="_blank">{item.title}</a></div>
                                <div className="item-text mt25 lheight-26">
                                    <BBCode plugins={[presetReact()]}>{steamToBBCode(item.contents)}</BBCode>
                                </div>
                            </div>
                            <div className="background-4" style={{ height: 40 }}></div>
                            <div className="author-comment table">
                                <div className="table-cell valign-left">
                                    <i className="fa fa-user color-white fsize-16" aria-hidden="true"></i>
                                    <span className="color-2 ml15 fsize-18">{item.author}</span>
                                </div>
                                <div className="table-cell valign-right" style={{textAlign: "right"}}>
                                    <a href={item.url} target="_blank">
                                        <i className="fa-solid fa-square-arrow-up-right color-white fsize-16"></i>
                                        <span className="color-8 fsize-18">Goto</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SteamNews;